import { render } from "./SunriseSunset.vue?vue&type=template&id=b43465f0&scoped=true"
import script from "./SunriseSunset.vue?vue&type=script&lang=js"
export * from "./SunriseSunset.vue?vue&type=script&lang=js"

import "./SunriseSunset.vue?vue&type=style&index=0&id=b43465f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b43465f0"]])

export default __exports__